import { useEffect, useLayoutEffect } from 'react'

// useLayoutEffect warns under SSR (renderToStaticMarkup); fall back to useEffect
// on the server. Shared by all motion hooks.
const useIso = typeof window !== 'undefined' ? useLayoutEffect : useEffect
export default useIso
